import { getTemplate, WidgetProps } from '@rjsf/utils';
import { Edit } from '@mui/icons-material';
import { PillIconButton } from 'components/button/PillIconButton';
import useDialog from '../../hooks/useDialog.tsx';
import ViewDialog from '../dialog/ViewDialog.tsx';
import SecretValueEdit from 'views/secrets/SecretValueEdit.tsx';
import { Secret } from 'api/model.ts';

const SecretValueWidget = (props: WidgetProps) => {
  const [showEditSecretValueDialog, EditSecretValueDialog] = useDialog(ViewDialog);

  const secret = props.options?.secret as Secret;

  const { options, registry } = props;
  const BaseInputTemplate = getTemplate('BaseInputTemplate', registry, options);

  const handleSubmit = (value: string) => {
    props.onChange(value);
    showEditSecretValueDialog(false);
  };

  return (
    <>
      <div className="flex w-100 flex-row items-center gap-2">
        <BaseInputTemplate {...props} className="grow" />
        <PillIconButton color="info" title="Edit value" onClick={() => showEditSecretValueDialog(true)}>
          <Edit />
        </PillIconButton>
      </div>
      <EditSecretValueDialog>
        <SecretValueEdit secret={secret} onCancel={() => showEditSecretValueDialog(false)} onSubmit={handleSubmit} />
      </EditSecretValueDialog>
    </>
  );
};
export default SecretValueWidget;
